import { styled } from '@linaria/react';
import { fonts, layout, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div<{ $error?: boolean; $bare?: boolean }>`
  display: flex;
  align-items: stretch;
  border: ${(p) =>
    p.$bare ? 'none' : `1px solid ${p.$error ? semantic.border.danger : semantic.border.default}`};
  border-radius: ${(p) => (p.$bare ? '0' : size.radius['radius-sm'])};
  box-sizing: border-box;
  width: 100%;
  position: relative;
  z-index: 1;

  &:focus-within {
    z-index: 100;
  }
`;

export const CountryCodeWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  position: relative;
  z-index: 10;

  && > div {
    width: auto;
    flex-direction: row;
    align-items: center;
  }

  && button[aria-haspopup='listbox'] {
    display: inline-flex;
    align-items: center;
    border: none;
    border-radius: 0;
    background: transparent;
    min-width: unset;
    width: auto;
    padding: ${layout.inputPadding};
    gap: ${space['space-200']};
    color: ${semantic.text.secondary};

    &:focus,
    &[data-open='true'] {
      background: ${semantic.bg.surfaceSubtle};
    }
  }

  && [role='listbox'] {
    left: 0;
    right: auto;
    min-width: 260px;
    max-width: 320px;
    border: 1px solid ${semantic.border.default};
    border-radius: ${size.radius['radius-sm']};
    top: calc(100% + ${space['space-100']});
  }
`;

export const FlagCircle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${fonts.size.lg};
  line-height: 1;
`;
